
import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface FortuneContainerProps {
  children: ReactNode;
  className?: string;
}

const FortuneContainer = ({ children, className = '' }: FortuneContainerProps) => {
  return (
    <motion.div
      className={`text-center max-w-lg mx-auto flex flex-col justify-center h-full min-h-[60vh] p-6 rounded-lg backdrop-blur-sm bg-white/10 ${className}`}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      {children}
    </motion.div>
  );
};

export default FortuneContainer;
